import storage from 'root/common/util/storage';

export const initSourceChannelParams = (options = {}) => {
    const { expires = 60 * 60 * 12 } = options;

    let reg = location.href.match(/sourceChannel=([^=&]+)/);
    if (reg && reg.length > 1) {
        reg[1] = reg[1].replace('#', '').replace('/', ''); // 防止前端路由自动跳转拼接问题
        storage.set(storage.keys['privilegeSourceChannel'], reg[1], {
            expires,
        });
    }

    reg = location.href.match(/sourceChannelSign=([^=&]+)/);
    if (reg && reg.length > 1) {
        reg[1] = reg[1].replace('#', '').replace('/', ''); // 防止前端路由自动跳转拼接问题
        storage.set(storage.keys['privilegeSourceChannelSign'], reg[1], {
            expires,
        });
    }
};
